<template>
  <div class="main-wrapper">
    <v-app-bar color="neutral3" app flat>
      <div class="d-flex align-center fill-width">
        <div class="d-flex justify-center align-center mr-8">
          <v-img
            :src="$settings?.profile?.logo"
            class="mr-2"
            max-width="2rem"
            height="2rem"
            contain
          />

          <span v-if="$vuetify.breakpoint.mdAndUp" class="text-h6">
            {{ _title }}
          </span>
        </div>

        <v-spacer v-if="$vuetify.breakpoint.smAndDown" />

        <div v-if="$vuetify.breakpoint.mdAndUp" class="d-flex align-center">
          <router-link
            v-for="(item, i) in routes"
            :key="i"
            class="mr-6 white--text text-body-1 text-decoration-none router-link"
            active-class="primary--text active-link"
            :to="item.path"
          >
            {{ item.label }}
          </router-link>
        </div>

        <v-menu v-else content-class="px-4 pt-1" min-width="100vw" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="menuOpen = !menuOpen">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>

          <v-card class="pa-2 rounded-lg" color="neutral3" width="100%">
            <v-list class="fill-width transparent" dense>
              <v-list-item
                v-for="(item, i) in routes"
                :key="i"
                :to="item.path"
                router
                @click="menuOpen = false"
              >
                <v-list-item-title class="font-weight-bold text-body-1">
                  {{ item.label }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-spacer />

        <v-btn class="btn pulse" color="primary" :href="_clientURL">
          Jogar agora
        </v-btn>
      </div>
    </v-app-bar>

    <router-view class="pb-16" />

    <v-footer dark padless>
      <v-card class="card pa-2" color="neutral" flat tile width="100%">
        <v-container class="pt-12">
          <v-row align="center" justify="space-around">
            <v-col cols="12" md="5">
              <div class="text-body-1 neutral8--text">
                O
                <span class="primary--text">{{ $settings.profile.name }}</span>
                é um jogo diário de adivinhação de palavras. O objetivo é
                simples: acertar a palavra do dia em até 6 tentativas. Ao
                acertar, você ganha números para concorrer ao sorteio diário de
                R$ 1.000,00 e outros prêmios. Além disso, você pode aumentar
                suas chances assistindo a vídeos patrocinados ou adquirindo
                boosters. Tudo isso em uma plataforma acessível e transparente,
                onde a diversão e a recompensa andam juntas.
              </div>
            </v-col>

            <v-col cols="12" md="5">
              <div class="d-flex flex-column flex-md-row">
                <div class="d-flex flex-column mb-4">
                  <div v-for="(item, i) in routes" :key="i" class="mb-2">
                    <router-link
                      :to="item.path"
                      class="text-decoration-none text-body-1"
                    >
                      <div class="text1--text">{{ item.label }}</div>
                    </router-link>
                  </div>
                </div>

                <v-divider
                  v-if="$vuetify.breakpoint.smAndUp"
                  class="primary mx-10"
                  vertical
                />

                <div>
                  <div
                    v-for="(item, i) in socialMidea"
                    :key="i"
                    class="d-flex mb-4"
                  >
                    <v-icon left>{{ item.icon }}</v-icon>
                    <div>{{ item.label }}</div>
                  </div>

                  <section>
                    <div class="text-h6 font-weight-bold russo-one mb-4">
                      Entre em Contato
                    </div>

                    <div>
                      <a
                        class="d-flex align-center text-body-1 text1--text mb-2"
                        target="_blank"
                        :href="`mailto:${_email}`"
                      >
                        <i class="fas fa-envelope mr-2"></i> Email:
                        <div class="ml-2 text1--text">
                          {{ _email }}
                        </div>
                      </a>

                      <a
                        class="d-flex align-center text-body-2 text1--text mb-2 flex-wrap"
                        :href="`https://wa.me/${_phoneNumber}?text=Ol%C3%A1!%20Preciso%20de%20ajuda%20com%20o%20jogo%20da%20Palavra%20Premiada.%20Voc%C3%AA%20pode%20me%20ajudar?%20Agrade%C3%A7o%20desde%20j%C3%A1!`"
                        target="_blank"
                      >
                        <i class="fab fa-whatsapp mr-2"></i> Whatsapp:

                        <div class="ml-2 mr-4">
                          {{ formatPhoneNumber(_phoneNumber) }}
                        </div>
                      </a>

                      <p class="text-body-2">
                        📍 Endereço:
                        <span class="text1--text">
                          {{ _address }}
                        </span>
                      </p>
                    </div>
                  </section>
                </div>
              </div>

              <v-img
                v-if="$vuetify.breakpoint.mdAndUp"
                :src="require('@/assets/main/polygon.png')"
                class="absolute polygon"
                max-width="8rem"
                contain
              />
            </v-col>
          </v-row>

          <v-divider class="my-4 neutral4" />

          <div class="text-center">
            © {{ new Date().getFullYear() }} —
            <strong>Gainmes Developer</strong> — Todos os direitos reservados.
          </div>

          <div class="text-center text-caption neutral8--text">
            V{{ _version }}
          </div>
        </v-container>
      </v-card>
    </v-footer>

    <v-btn
      v-if="false"
      color="green accent-4"
      width="3rem"
      target="_blank"
      height="3rem"
      :href="_whatsappURL"
      bottom
      right
      dark
      fixed
      fab
    >
      <v-icon large>fab fa-whatsapp</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getRaffles } from "@/services/raffles";
import { formatPhoneNumber } from "@/helpers";

export default {
  name: "Main",

  data() {
    return {
      menuOpen: false,
      routes: [
        {
          label: "Início",
          path: "/home",
        },
        ...(this.$features.raffles
          ? [
              {
                label: "Ganhadores",
                path: "/winners",
              },
            ]
          : []),
        {
          label: "Sobre",
          path: "/about",
        },
        {
          label: "Ajuda",
          path: "/help",
        },
        {
          label: "Termos",
          path: "/terms",
        },
      ],
      socialMidea: [],
    };
  },

  created() {
    this.getData();
  },

  beforeMount() {
    this.handleQueryCode();
  },

  computed: {
    ...mapGetters({
      _currentRaffle: "currentRaffle",
    }),

    _title() {
      return this.$settings.profile.name;
    },

    _clientURL() {
      return this.$settings.clientURL;
    },

    _whatsappURL() {
      return this.$settings.profile?.whatsappGroup;
    },

    _email() {
      return this.$settings.profile?.email;
    },

    _phoneNumber() {
      return this.$settings.profile?.phone;
    },

    _address() {
      const address = this.$settings.profile?.address;
      const street = address.street ? address.street + ", " : "";
      const number = address.number ? address.number + ", " : "";
      const complement = address.complement ? address.complement + ", " : "";
      const neighborhood = address.neighborhood
        ? address.neighborhood + ", "
        : "";
      const zipCode = address.zipCode ? address.zipCode + ", " : "";
      const city = address.city ? address.city + ", " : "";
      const state = address.state ? address.state + ", " : "";
      const country = address.country ? address.country + ", " : "";

      return (
        street +
        number +
        complement +
        neighborhood +
        zipCode +
        city +
        state +
        country
      );
    },

    _version() {
      return process.env.VUE_APP_VERSION;
    },
  },

  methods: {
    ...mapActions(["setCurrentRaffle"]),

    async getData() {
      // await this.getGames();
      await this.getOpenRaffle();
    },

    async getOpenRaffle() {
      try {
        const payload = {
          status: ["open"],
        };

        const { data } = await getRaffles(payload);

        if (!data?.length) return;

        this.setCurrentRaffle(data[0]);
      } catch (error) {
        this.$alert(error?.message, "error");
      }
    },

    handleQueryCode() {
      const code =
        this.$route?.query?.code || this.$route?.params?.code || false;

      if (code) {
        window.location.href = `${this._clientURL}/auth/sign-up?code=${code}`;
      }
    },

    formatPhoneNumber,
  },
};
</script>

<style lang="scss" src="./style.scss" scoped />
